
<div class="container">
  <form class="cdf">
    <div class="row step-description-block">
      <div class="col">
        <div class="float-left">
          <h2>Synchronize Project CDF data</h2>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <error [error]="error"></error>
      </div>
    </div>
    <cdf-import [projectId]="projectId" (error)="handleError($event)"></cdf-import>
  </form>
</div>